import { render, staticRenderFns } from "./panoramicMaterial.vue?vue&type=template&id=155e4369&"
import script from "./panoramicMaterial.vue?vue&type=script&lang=js&"
export * from "./panoramicMaterial.vue?vue&type=script&lang=js&"
import style0 from "./panoramicMaterial.vue?vue&type=style&index=0&id=155e4369&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports